import { StyledSvg } from "baseui/icon";
import React from "react";

export const CopyIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 30 30" {...props}>
    <path d="M11 2C9.895 2 9 2.895 9 4V20C9 21.105 9.895 22 11 22H24C25.105 22 26 21.105 26 20V8.5C26 8.235 25.895 7.98097 25.707 7.79297L20.207 2.29297C20.019 2.10497 19.765 2 19.5 2H11ZM19 3.9043L24.0957 9H20C19.448 9 19 8.552 19 8V3.9043ZM6 7C4.895 7 4 7.895 4 9V25C4 26.105 4.895 27 6 27H19C20.105 27 21 26.105 21 25V24H11C8.794 24 7 22.206 7 20V7H6Z" />
  </StyledSvg>
);
